<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <PaymentReceiptStatusFilter
            ref="paymentReceiptStatusFilterRef"
            :multiple="false"
            @onPaymentReceiptStatusFilterChanged="onPaymentReceiptStatusFilterChanged"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <PaymentReceiptErrorFilter
            ref="paymentReceiptErrorFilterRef"
            :multiple="false"
            @onPaymentReceiptErrorFilterChanged="onPaymentReceiptErrorFilterChanged"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <WBSearchQueryFilter
            ref="searchQueryFilterRef"
            :remote-option-value="undefined"
            :label="'Поиск по номеру смены или задания'"
            dense
            outlined
            @onSearchQueryFilterChange="onSearchQueryFilterChange"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <WBDOrganizationSelectorFilter
            ref="organizationListSelectorFilterRef"
            :remote-list="[]"
            :selected-option-value="''"
            dense
            outlined
            @onOrganizationListSelectorFilterChange="onOrganizationListSelectorFilterChange"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <WBDManagerUserFilter
            ref="managerUserSelectorFilterRef"
            :remote-list="[]"
            :label="'Поиск пользователя БО'"
            dense
            outlined
            :remote-selected-list-list="''"
            @onManagerUserFilterChanged="onManagerUserFilterChanged"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <DatePickerRangeSelector
            ref="endDateIntervalFilterRef"
            :on-date-change-event="'onStartAtChange'"
            :clear-event="eventNames.RELAY_START_DATE_FILTER_RESET"
            :label="'Выберите интервал дат конца смены'"
            :remote-date="internalSync.endDateInterval"
            outlined
            dense
            @onStartAtChange="onendDateIntervalChange"
          />
        </v-col>
        <v-col
          v-if="formMode !== 'laborer'"
          cols="12"
          md="6"
        >
          <WBDAutocompleteSearch
            ref="laborerAutocompleteSearchRef"
            :model-type="modelTypeSet.MODEL_TYPE_LABORER"
            :label="'Поиск пользователей по ФИО, ИНН, СНИЛС, Почте, Тел'"
            dense
            @wbdAutoCompleteSelected="onWbdAutoCompleteSelected"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        text
        :disabled="!hasSelectedFilters"
        @click="clearFilters"
      >
        Очистить
      </v-btn>
      <v-btn
        text
        color="success"
        outlined
        rounded
        @click="onRequestData"
      >
        Применить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import WBDAutocompleteSearch from '@/components/common/autocomplete/index.vue'
import DatePickerRangeSelector from '@/components/common/filter/date-picker-range-selector.vue'
import WBDOrganizationSelectorFilter from '@/components/common/filter/organization-selector-filter.vue'
import WBDManagerUserFilter from '@/components/common/filter/v2/manager-user-filter.vue'
import WBSearchQueryFilter from '@/components/common/filter/search-query-filter.vue'
import PaymentReceiptStatusFilter from
'@/components/common/filter/v2/relayPaymentReveipt/payment-receipt-status-filter.vue'
import PaymentReceiptErrorFilter from
'@/components/common/filter/v2/relayPaymentReveipt/payment-receipt-error-filter.vue'

export const PaymentReceiptFilterModel = {
  searchQuery: null,
  laborer: null,
  status: null,
  endDateInterval: null,
  organization: null,
  rejectReason: null,
  supervisor: null,
}

export const externalTaskDashboardParamsMapper = (filterSet) => {
  const params = {}
  const { status, laborer, organization, supervisor, endDateInterval, rejectReason, searchQuery } =
      filterSet

  if (searchQuery) {
    params.number = searchQuery
  }
  if (rejectReason) {
    params.rejectReason = rejectReason.id
  }
  if (status) {
    params.status = status.id
  }
  if (laborer) {
    params['laborer[id]'] = laborer.id
  }
  if (organization) {
    params['organization[id]'] = organization.id
  }
  if (supervisor) {
    params['supervisor[id]'] = supervisor.id
  }
  if (endDateInterval && Array.isArray(endDateInterval) && endDateInterval.length) {
    params['endDateInterval[from]'] = endDateInterval[0]
    if (endDateInterval.length > 1) {
      params['endDateInterval[to]'] = endDateInterval[1]
    }
  }

  return params
}


export default {
  name: 'DocumentDashboardFilters',
  components: {
    PaymentReceiptErrorFilter,
    PaymentReceiptStatusFilter,
    WBSearchQueryFilter,
    WBDManagerUserFilter,
    WBDOrganizationSelectorFilter,
    DatePickerRangeSelector,
    WBDAutocompleteSearch,
  },
  props: {
    formMode: String,
    teamEnabled: Boolean,
    initialFiltersFilters: {
      type: Object,
      default: () => ({ ...PaymentReceiptFilterModel }),
    },
  },
  data () {
    return {
      internalSync: { ...PaymentReceiptFilterModel },
    }
  },
  computed: {
    hasSelectedFilters () {
      let hasValidFilters = 0
      for (const item of Object.values(this.internalSync)) {
        if (item) {
          ++hasValidFilters
        }
      }
      return hasValidFilters > 0
    },
  },
  watch: {
    initialFiltersFilters: {
      immediate: true,
      handler (newSync) {
        this.internalSync = { ...newSync }
      },
    },
  },
  methods: {
    onWbdAutoCompleteSelected (data) {
      this.internalSync.laborer = data
    },
    onOfferLevelChanged (data) {
      this.internalSync.isStaffMember = data
    },
    onendDateIntervalChange (data) {
      this.internalSync.endDateInterval = data
    },
    onOrganizationListSelectorFilterChange (data, org) {
      this.internalSync.organization = org
    },
    onManagerUserFilterChanged (data) {
      this.internalSync.supervisor = data
    },
    onSearchQueryFilterChange (data) {
      this.internalSync.searchQuery = data
    },
    onPaymentReceiptStatusFilterChanged (data) {
      this.internalSync.status = data
    },
    onPaymentReceiptErrorFilterChanged (data) {
      this.internalSync.rejectReason = data
    },
    onRequestData () {
      this.$emit('onRequestData', { filters: externalTaskDashboardParamsMapper(this.internalSync) })
    },
    clearFilters () {
      this.internalSync = PaymentReceiptFilterModel
      this.internalSync.organization = null
      this.internalSync.supervisor = null
      this.internalSync.searchQuery = null

      // Forcefully clear the values in the child components
      this.$nextTick(() => {
        this.$refs.laborerAutocompleteSearchRef.onClear()
        this.$refs.endDateIntervalFilterRef.onClear()
        this.$refs.organizationListSelectorFilterRef.onClear()
        this.$refs.managerUserSelectorFilterRef.onClear()
        this.$refs.searchQueryFilterRef.onClear()
        this.$refs.paymentReceiptErrorFilterRef.onClear()
        this.$refs.paymentReceiptStatusFilterRef.onClear()
      })
    },
  },
}
</script>

<style scoped>
/* Add any custom styles if necessary */
</style>
